// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class DatepickerService {
   dateRangeService: any
   datepicker: any
   pickerPrototype: any
   constructor(dateRangeService: any) {

      this.retrieveSince = this.retrieveSince.bind(this)
      this.update = this.update.bind(this)
      this.clear = this.clear.bind(this)
      this.clean = this.clean.bind(this)
      this.dateRangeService = dateRangeService
      this.pickerPrototype = {
         date: {
            start: null,
            end: null
         },
         error: false
      }

      this.datepicker = {
         search: angular.copy(this.pickerPrototype),
         update: this.update,
         clear: this.clear,
         clean: this.clean
      }

      this.datepicker.search.date = this.dateRangeService.selection
      this.datepicker.datePresets = this.dateRangeService.defaultPresets
      this.datepicker.datePresetLabels = this.dateRangeService.datePresetLabels
   }


   retrieveSince(years: any){
      return _.extend(this.datepicker.search.date, this.dateRangeService.retrieveSince(years))
   }

   update(source: any, attrs: any, advancedScopeName = '', advSearchScopeParams = null, advSearchScopeCallBackOnCancel = angular.noop) {
      const updateDate = (goBackToSearchScope = false, attributes = attrs) => {
         if(!goBackToSearchScope){
            attributes.selectedYears = this.dateRangeService.determinePresetSelectedYears(attributes.start, attributes.end)
            this.datepicker.search.date = {...attributes}
            if (source === 'refine') {
               this.dateRangeService.setSelection(attributes)
               this.dateRangeService.applySelection()
            } else {
               const advanced = true
               this.dateRangeService.setSelection(attributes, advanced)
            }
         } else if (source === 'advancedSearch') {
            advSearchScopeCallBackOnCancel()
         } else {
            this.dateRangeService.reflectEitherParams()
         }
      }
      const dateParams = {...attrs}
      
      if(this.dateRangeService.checkForSearchScope(advancedScopeName, advSearchScopeParams, updateDate, dateParams)){
         return
      }
      
      updateDate()
   }

   clear(type = "search", applyState = true) {
      if(this.dateRangeService.checkForSearchScope() && applyState){
         return
      }
      const picker = this.datepicker[type]
      picker.date.start = null
      picker.date.end = null
      picker.error = false
      if (type === "search") { return this.dateRangeService.clearSelection(applyState) }
   }

   clean() {
      if (this.datepicker.search.date.start === undefined) { this.datepicker.search.date.start = null }
      if (this.datepicker.search.date.end === undefined) { this.datepicker.search.date.end = null }
      return this.datepicker.search.error = false
   }
}

DatepickerService.$inject = ['dateRangeService']

angular.module('summonApp.services')
   .service('datepickerService', DatepickerService)
